module.exports = __webpack_public_path__ + "static/media/lalityaron190408_2.bea4cf48.jpg";